// One-line pieces of a buyer's saved preferences, as returned by the backend's
// buyer_property_match.preference_summary (DOMA 13374913603).

const money = (n) => {
  if (n == null) return '';
  if (n >= 1000000) return `$${Number((n / 1000000).toFixed(2))}m`;
  if (n >= 1000) return `$${Math.round(n / 1000)}k`;
  return `$${n}`;
};

const range = (lo, hi, unit, fmt = String) => {
  if (lo != null && hi != null) return lo === hi ? `${fmt(lo)} ${unit}` : `${fmt(lo)} to ${fmt(hi)} ${unit}`;
  if (lo != null) return `${fmt(lo)}+ ${unit}`;
  if (hi != null) return `up to ${fmt(hi)} ${unit}`;
  return '';
};

export const preferenceParts = (prefs) => {
  if (!prefs) return [];
  const price = range(prefs.price_min, prefs.price_max, '', money).trim();
  return [
    prefs.suburbs?.length ? prefs.suburbs.join(', ') : '',
    price,
    range(prefs.beds_min, prefs.beds_max, 'beds'),
    prefs.baths != null ? `${prefs.baths}+ baths` : '',
    prefs.cars != null ? `${prefs.cars}+ cars` : '',
    prefs.property_types?.length ? prefs.property_types.join(', ') : '',
  ].filter(Boolean);
};

export const formatMoney = money;
